"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var TextData_1 = require("./TextData");
var TextAnimatorData = (function (_super) {
    tslib_1.__extends(TextAnimatorData, _super);
    function TextAnimatorData(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        if (_this._rawData.d) {
            _this.data = new TextData_1.TextData(_this._rawData.d, version);
        }
        return _this;
    }
    return TextAnimatorData;
}(AnimationObject_1.AnimationObject));
exports.TextAnimatorData = TextAnimatorData;
//# sourceMappingURL=TextAnimatorData.js.map